import { useQuery } from 'react-query'
import { getUserInfo } from './calls'

export const useUserInfo = () => {
  return useQuery('user-info', getUserInfo)
}
